import React from 'react';

import { Card, Skeleton, Typography } from 'antd';

import { Semester } from './components/Semester';

import { table } from './struct';


const { Title } = Typography;

const Plan11 = ({ title, state }) => {

  return (
    <Card {...table.wrapper}>
      <Title level={5}>{title ? title : ''}</Title>
      <br />
      {state ? (
        state?.planning?.length > 0 && state?.planning.map((semester) => (
          <>
            <Semester
              key={semester.semester}
              semesterDetail={semester}
              teaching={semester?.teaching || []}
              supervision={semester?.supervision || []}
            />
            <br />
          </>
        ))
      ) : (
        <Skeleton loading={!state ? true : false} active />
      )}

    </Card>
  );
};

export default Plan11;
